module.exports = "https://assets.meiaentrada.org.br/static/media/padrao-nacional-da-cie-2025-vf.308e7829.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/documents/padrao-nacional-da-cie-2025-vf.pdf
// module id = 257
// module chunks = 0